import React, { useEffect } from "react";
import { Col, Row, Button, Card, Spin } from "antd";
import {
  NiblesBreadDashboardButtonicon,
  PizzaShapeIcon,
} from "../asset/icons/icons";
import noorderhistory from "../asset/noorderhistory.png";
import ProductCard from "./productcard";
import { useDispatch, useSelector } from "react-redux";
import { getAllUserOrders } from "../redux/Actions";
import { getOrderReducer } from "../redux/Reducer/orderReducer";
import OrderHistoryTable from "./OrderHistoryTable";

const UserDashboardContent = (props) => {
  const {
    setCart,
    cart,
    setDetailQtyAdded,
    handleAddToCart,
    allProducts,
    isloadingallProducts,
    authuserdetails,
    detailsQtyAdded,
    isloadingAddedCartItem,
  } = props;

  // const [currentPage, setCurrentPage] = useState(1);
  const { allUserOrders, isloadingAllUserOrders } =
    useSelector(getOrderReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllUserOrders(authuserdetails?.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userLocation = authuserdetails?.location_id;
  const userType = authuserdetails?.user_type_id;

  // Filter products by location and user type
  // Optional: Sort Promos to the top if desired. Currently just filtering.
  const filteredProducts = allProducts?.filter(
    (item) =>
      item?.user_type_id === userType && item?.location_id === userLocation,
  );

  return (
    <>
      <Row
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >
        <Col
          className="gutter-row"
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
        >
          <Col className="dashboardtitlescol" span={24}>
            <p className="dashboardtitlestypog">Available Bread in stock</p>
          </Col>
          <Col span={24}>
            <Row justify="space-between">
              <Col
                xs={{ span: 24 }}
                sm={{ span: 14 }}
                md={{ span: 14 }}
                lg={{ span: 16 }}
                xl={{ span: 10 }}
              >
                <Button
                  type="text"
                  size={"large"}
                  className="typography dashboardnibblesbutton1Heading1"
                >
                  <p className="dashboardnibblesbutton1typogHeading1">
                    Nibbles Bread
                    <span
                      style={{ marginLeft: ".8em" }}
                      className="buttonendicons"
                    >
                      <NiblesBreadDashboardButtonicon />
                    </span>
                  </p>
                </Button>
                <Button
                  type="text"
                  size={"large"}
                  className="typography dashboardnibblesbutton2Heading2"
                >
                  <p className="dashboardnibblesbutton2typogHeading2">
                    Sun Crust
                    <span
                      style={{ marginLeft: ".8em" }}
                      className="buttonendicons"
                    >
                      <PizzaShapeIcon />
                    </span>
                  </p>
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 10 }}
                md={{ span: 10 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
              >
                {/* Search Box area (currently commented out in original) */}
              </Col>
            </Row>
          </Col>

          <Col className="dashboardcardscol" span={24}>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              {isloadingallProducts ? (
                <div className="spinner-containers">
                  <Spin size="large" />
                </div>
              ) : (
                filteredProducts?.map((items, i) => (
                  <ProductCard
                    item={items}
                    key={i}
                    onAddToCart={handleAddToCart}
                    isloadingAddedCartItem={isloadingAddedCartItem}
                    setCart={setCart}
                    cart={cart}
                    setDetailQtyAdded={setDetailQtyAdded}
                    detailsQtyAdded={detailsQtyAdded}
                  />
                ))
              )}
            </Row>
          </Col>

          <Col className="dashboardcardscol" span={24}>
            <Card title="View Order History" bordered={false}>
              {allUserOrders && allUserOrders?.data?.length !== 0 ? (
                <OrderHistoryTable
                  allUserOrders={allUserOrders}
                  isloadingAllUserOrders={isloadingAllUserOrders}
                />
              ) : (
                <p style={{ textAlign: "center" }}>
                  <img
                    src={noorderhistory}
                    alt="no order history"
                    height={"260px"}
                    draggable={false}
                  />
                </p>
              )}
            </Card>
          </Col>
        </Col>
      </Row>
    </>
  );
};
export default UserDashboardContent;
